/**
 * Module dependencies.
 */

import { Checkbox as CheckboxPrimitive } from 'app/components/ui/checkbox';
import { ErrorField } from '../../error-field/error-field';
import { FormField } from '../../form-field/form-field';
import { Label } from 'app/components/ui/label';
import { cn } from 'app/lib/utils';
import React, { forwardRef } from 'react';

/**
 * `Props` type.
 */

export type CheckboxProps = {
  className?: string;
  disabled?: boolean;
  error: any;
  fieldClassName?: string;
  invalid?: boolean;
  isDirty?: boolean;
  isTouched?: boolean;
  label: string;
  name?: string;
  onBlur?: () => void;
  onChange?: (event: { nativeEvent: { target: { checked: boolean } } }) => void;
  value?: boolean;
};

/**
 * Export `CheckboxComponent` component.
 */

export function CheckboxComponent(props: CheckboxProps, forwardedRef: any): JSX.Element {
  const { className, disabled, error, fieldClassName, invalid, isTouched, label, name, onBlur, onChange, value } =
    props;

  return (
    <FormField className={className}>
      <div className={'flex items-center gap-2'}>
        <CheckboxPrimitive
          checked={!!value}
          className={cn(fieldClassName)}
          disabled={disabled}
          name={name}
          onBlur={onBlur}
          onCheckedChange={checked => {
            onChange?.({ nativeEvent: { target: { checked: checked === true } } });
          }}
          ref={forwardedRef}
        />

        <Label className={'cursor-pointer text-sm font-medium leading-none'}>{label}</Label>
      </div>

      <ErrorField error={error} isVisible={invalid || isTouched} />
    </FormField>
  );
}

/**
 * Export `Checkbox` component.
 */

export const Checkbox = forwardRef<any, CheckboxProps>(CheckboxComponent);
